import { render, staticRenderFns } from "./HealthCode.vue?vue&type=template&id=7f46548b&scoped=true"
import script from "./HealthCode.vue?vue&type=script&lang=js"
export * from "./HealthCode.vue?vue&type=script&lang=js"
import style0 from "./HealthCode.vue?vue&type=style&index=0&id=7f46548b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f46548b",
  null
  
)

export default component.exports